<div
  class="fixed bottom-0 left-0 right-0 top-0 flex h-screen items-center justify-center bg-white"
  [style.z-index]="((index$ | async) ?? 0) + 90"
>
  <div class="text-md md:text-xl lg:text-4xl">
    {{ 'waiting-modal.please-wait' | translate }}
  </div>
</div>
